
import Detailaccredited from '../detailaccredited/detailaccredited.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tablebrokers from '../tablebrokers/tablebrokers.vue'
import Tableenterprise from '../tableenterprise/tableenterprise.vue'

const Tabs = {
  Detalhes: 0,
  Corretores: 1,
  Empreendimento: 2
}

export default {
  props: ['dataedit'],
  name: 'Painelaccredited',
  mixins: [ActionsForm],
  components: {Detailaccredited, Tablebrokers, Tableenterprise},

  data () {
    return {
      headTable: ['Corretores', 'Empreendimento'],
      tabIndex: Tabs.Detalhes,
      selectedComissao: {}
    }
  },
  methods: {
    update () {
      this.$emit('updateAbstractaccredited')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/painelaccredited/painelaccredited.js